module.exports = __webpack_public_path__ + "static/img/1954_34ForAPianist_London_1.76bd785.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1954_34ForAPianist_London_1.jpg
// module id = yCw4
// module chunks = 0